<template>
  <v-autocomplete
    v-model="input_value"
    :items="rows"
    :loading="isLoading"
    :search-input.sync="search"
    item-text="label"
    item-value="id"
    :label="$t('admin.app.photobooth_config')"
    outlined
    rounded
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.label" />
        <v-list-item-subtitle v-text="item.registry.label" />
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    filterBy: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: 'Hilos de preguntas',
    },
  },
  data: () => ({
    search: null,
  }),
  computed: {
    ...mapState({
      items: (state) => state.constants.run_time.photobooth_configs,
      isLoading: (state) => state.constants.is_loading.photobooth_configs,
    }),
    rows() {
      if (this.filterBy) {
        return this.items.filter((row) => {
          return this.filterBy == row.registry_id
        })
      }
      return this.items
    },
    input_value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  mounted() {
    if (this.items.length > 0) return
    this.loadRows()
  },
  methods: {
    loadRows() {
      this.$store.dispatch('constants/loadPhotoboothConfigs')
    },
  },
}
</script>

<style></style>
